import React, { useContext } from 'react'
import classes from './TechnicalExpertisePreviewBlock.module.css'
import { ThemeContext } from '../../App'

interface TechnicalExpertisePreviewBlockProps {
  technicalExpertisePrivewBlock: {
    firstTitle: string,
    secondTitle: string,
    bottomText: string
  }
}



const TechnicalExpertisePreviewBlock: React.FC<TechnicalExpertisePreviewBlockProps> = ({
  technicalExpertisePrivewBlock: { firstTitle, secondTitle, bottomText }, }) => {

  const isUIpage = firstTitle.startsWith("UI");
  const { theme } = useContext(ThemeContext)

  return (
    <div id={classes[theme]} className={classes.previewContainer + " " + (isUIpage ? classes.backgroundForPreviewBlock : "") + " flex flex-col justify-center"}>
      <div className={"px-10 md:mt-10 lg:mt-0 lg:px-20"}>
        <h3 className='text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt mb-5 lg:mb-0'>{firstTitle}</h3>
        <h3 className={classes.secondH3 + ' text-cyan-400 text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt'}>{secondTitle}</h3>
        <p className='w-4/5 hidden lg:block'>{bottomText}</p>
      </div>
    </div>
  )
}


export default TechnicalExpertisePreviewBlock
